import { render, staticRenderFns } from "./markdown.vue?vue&type=template&id=8994ecd2&scoped=true&"
import script from "./markdown.vue?vue&type=script&lang=js&"
export * from "./markdown.vue?vue&type=script&lang=js&"
import style0 from "./markdown.vue?vue&type=style&index=0&id=8994ecd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8994ecd2",
  null
  
)

export default component.exports